import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, Button } from '@mui/material';
import { replaceStylesheetGlobals } from '../../portal/theme/portalTheme';
import { useTokens } from '../../tokens/TokensProvider';
const CheckoutFlow = ({ isVisible, productTitle, checkoutText, onCheckout, containerSX = {}, buttonSX = {}, stylesheet, buttonStyle, }) => {
    const tokens = useTokens();
    const resolvedCheckoutText = checkoutText || tokens.getValue('checkoutLabel');
    // Generate consistent success message
    const successMessage = `Great Choice! Your product "${productTitle}" has been added to your cart`;
    if (!isVisible) {
        return null;
    }
    // Get message font styling from stylesheet - site.system.pages.message.font
    const messageFont = stylesheet?.site?.system?.pages?.message?.font || {};
    const defaultContainerStyles = {
        mt: 2,
        p: 2,
        backgroundColor: replaceStylesheetGlobals(stylesheet, 'color_background') || '#f0f9ff',
        borderRadius: 2,
        border: `1px solid ${replaceStylesheetGlobals(stylesheet, 'color_primary_disabled') || '#e0f2fe'}`,
    };
    const containerStyles = { ...defaultContainerStyles, ...containerSX };
    return (_jsxs(Box, { sx: containerStyles, children: [_jsx(Typography, { variant: "body2", sx: {
                    color: replaceStylesheetGlobals(stylesheet, messageFont.color || 'color_primary') || '#0369a1',
                    fontSize: messageFont.fontSize ? `${messageFont.fontSize}px` : '0.9rem',
                    fontWeight: messageFont.fontWeight || 600,
                    textTransform: messageFont.textTransform || 'none',
                    mb: 1.5,
                    textAlign: 'center',
                }, children: successMessage }), _jsx(Button, { variant: "contained", onClick: onCheckout, sx: {
                    width: '100%',
                    backgroundColor: buttonStyle?.backgroundColor
                        ? replaceStylesheetGlobals(stylesheet, buttonStyle.backgroundColor)
                            || buttonStyle.backgroundColor
                        : '#1f2937',
                    color: buttonStyle?.color
                        ? replaceStylesheetGlobals(stylesheet, buttonStyle.color)
                            || buttonStyle.color
                        : 'white',
                    fontWeight: 600,
                    fontSize: '1rem',
                    py: 1.5,
                    '&:hover': {
                        backgroundColor: buttonStyle?.hoverBackgroundColor
                            ? replaceStylesheetGlobals(stylesheet, buttonStyle.hoverBackgroundColor)
                                || buttonStyle.hoverBackgroundColor
                            : '#374151',
                    },
                    ...buttonSX, // This overrides everything above if needed
                }, children: resolvedCheckoutText })] }));
};
CheckoutFlow.defaultProps = {
    checkoutText: '',
    containerSX: {},
    buttonSX: {},
    stylesheet: undefined,
    buttonStyle: undefined,
};
export default CheckoutFlow;
//# sourceMappingURL=CheckoutFlow.js.map